module.exports = __webpack_public_path__ + "img/waterLegendVehicle.468254c2.svg";